import { fetchConsentViewsByDiaryId } from "@/features/consent/api/selectConsentById";
import { getNextUnsignedConsent } from "@/features/consent/utils/consentGating";

export async function getPostSetupTarget(diaryId: string, userId?: string) {
    const consents = await fetchConsentViewsByDiaryId(diaryId);
    const nextConsent = userId ? getNextUnsignedConsent(consents, userId) : null;

    if (nextConsent?.consent_id) {
        return {
            to: "/diaries/$diaryId/setup/consent/$consentId" as const,
            params: { diaryId, consentId: nextConsent.consent_id },
        };
    }

    return {
        to: "/diaries/$diaryId/setup/complete" as const,
        params: { diaryId },
    };
}
